import {FirebaseApp} from 'firebase/app'
import {Functions, getFunctions, httpsCallable} from 'firebase/functions'

let functions: Functions

const init = (app: FirebaseApp) => {
    functions = getFunctions(app)
}

const registerTenant = async (data: Object) => {
    const callable = httpsCallable(functions, 'tenant-registerTenant')
    return await callable(data)
        .then((res: any) => res)
        .catch(console.error)
}

const useFunctionService = () => {
    return {
        init,
        registerTenant
    }
}

export {useFunctionService}

